// utils/isPastDate.ts

// function parseLocalizedDate(dateStr: string): Date | null {
//   const monthMap: Record<string, string> = {
//     // Болгарский
//     януари: "01", февруари: "02", март: "03", април: "04", май: "05",
//     юни: "06", юли: "07", август: "08", септември: "09", октомври: "10",
//     ноември: "11", декември: "12",

//     // Польский
//     stycznia: "01", lutego: "02", marca: "03", kwietnia: "04", maja: "05",
//     czerwca: "06", lipca: "07", sierpnia: "08", września: "09",
//     października: "10", listopada: "11", grudnia: "12",

//     // Венгерский
//     január: "01", február: "02", március: "03", április: "04", május: "05",
//     június: "06", július: "07", augusztus: "08", szeptember: "09",
//     október: "10", november: "11", december: "12",
//   };

//   const regex = /(\d{1,2})\s+(\p{L}+)\s+(\d{4})/u;
//   const match = dateStr?.trim().match(regex);
//   if (!match) return null;

//   // eslint-disable-next-line @typescript-eslint/no-unused-vars
//   const [_, day, monthWord, year] = match;
//   const month = monthMap[monthWord.toLowerCase()];
//   if (!month) return null;

//   const formatted = `${year}-${month}-${day.padStart(2, "0")}`;
//   return new Date(formatted);
// }

// export function isPastDate(dateStr: string): boolean {
//   const parsedDate = parseLocalizedDate(dateStr);
//   if (!parsedDate) return false;

//   const today = new Date();
//   today.setHours(0, 0, 0, 0);
//   parsedDate.setHours(0, 0, 0, 0);

//   return parsedDate <= today;
// }

function parseLocalizedDate(dateStr: string): Date | null {
  if (!dateStr) return null;

  const monthMap: Record<string, string> = {
    // Болгарский
    януари: "01",
    февруари: "02",
    март: "03",
    април: "04",
    май: "05",
    юни: "06",
    юли: "07",
    август: "08",
    септември: "09",
    октомври: "10",
    ноември: "11",
    декември: "12",

    // Польский
    stycznia: "01",
    lutego: "02",
    marca: "03",
    kwietnia: "04",
    maja: "05",
    czerwca: "06",
    lipca: "07",
    sierpnia: "08",
    września: "09",
    października: "10",
    listopada: "11",
    grudnia: "12",

    // Венгерский
    január: "01",
    február: "02",
    március: "03",
    április: "04",
    május: "05",
    június: "06",
    július: "07",
    augusztus: "08",
    szeptember: "09",
    október: "10",
    november: "11",
    december: "12",

    // Словацкий
    januára: "01",
    februára: "02",
    //marca: "03",
    apríla: "04",
    mája: "05",
    júna: "06",
    júla: "07",
    augusta: "08",
    septembra: "09",
    októbra: "10",
    novembra: "11",
    decembra: "12",

    // Чешский
    leden: "01",
    únor: "02",
    březen: "03",
    duben: "04",
    květen: "05",
    červen: "06",
    červenec: "07",
    srpen: "08",
    září: "09",
    říjen: "10",
    listopad: "11",
    prosinec: "12",

    // Румынский
    ianuarie: "01",
    februarie: "02",
    martie: "03",
    aprilie: "04",
    mai: "05",
    iunie: "06",
    iulie: "07",
    august: "08",
    septembrie: "09",
    octombrie: "10",
    noiembrie: "11",
    decembrie: "12",
  };

  // seeking digits & words - create tokens
  const tokens = dateStr
    .trim()
    .split(/\s+/)
    .map((t) => t.replace(/\./g, "")); // delete all dots

  let day: string | null = null;
  let month: string | null = null;
  let year: string | null = null;

  for (const token of tokens) {
    if (/^\d{4}$/.test(token)) {
      year = token;
    } else if (/^\d{1,2}$/.test(token)) {
      day = token;
    } else {
      const m = monthMap[token.toLowerCase()];
      if (m) month = m;
    }
  }

  if (!day || !month || !year) return null;

  const formatted = `${year}-${month}-${day.padStart(2, "0")}`;
  return new Date(formatted);
}

export function isPastDate(dateStr: string | null): boolean {
  if (!dateStr) return false;

  const parsedDate = parseLocalizedDate(dateStr);
  if (!parsedDate) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  parsedDate.setHours(0, 0, 0, 0);

  return parsedDate <= today;
}
